import PropTypes from "prop-types";

import QuizQuestionCheckbox from "../QuizQuestionCheckbox";
import ReadingSkillsAssessMessage from "../ReadingSkillsAssessMessage";
import { listContainerCss } from "./QuizOverviewContainer.style";

const propTypes = {
  quizData: PropTypes.object.isRequired,
  quizQuestionMetadata: PropTypes.object,
};

const QuizOverviewContainer = ({ quizData, quizQuestionMetadata }) => {
  return (
    <>
      <ReadingSkillsAssessMessage />
      {quizData && (
        <ul css={listContainerCss}>
          {quizData?.questions.map((question) => {
            const questionMetadata = quizQuestionMetadata?.[question.id];

            return (
              <QuizQuestionCheckbox
                key={question.position}
                question={question}
                questionMetadata={questionMetadata}
              />
            );
          })}
        </ul>
      )}
    </>
  );
};

QuizOverviewContainer.propTypes = propTypes;

export default QuizOverviewContainer;
